// extracted by mini-css-extract-plugin
export default {"inputs":"BaseInputBox_inputs__-D8K8","header":"BaseInputBox_header__YIPLF","text":"BaseInputBox_text__JFUuQ","numberOfInputs":"BaseInputBox_numberOfInputs__GU8Ix"};